"use strict";
/*
 * Created on 01 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SelloutCategoryDiscount_1 = require("../model/SelloutCategoryDiscount");

var SelloutSubSettings_1 = require("../model/SelloutSubSettings");

var SelloutSubSettingsConverter_1 = require("./SelloutSubSettingsConverter");
/**
 * @author Jaroslav Sevcik
 */


var SelloutSubSettingsConverterImpl =
/*#__PURE__*/
function (_SelloutSubSettingsCo) {
  _inherits(SelloutSubSettingsConverterImpl, _SelloutSubSettingsCo);

  function SelloutSubSettingsConverterImpl() {
    _classCallCheck(this, SelloutSubSettingsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSubSettingsConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutSubSettingsConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      return {
        remodelingDaysBeforeClosure: source.remodelingDaysBeforeClosure,
        categoryDiscounts: source.categoryDiscounts && conversions.asObjectArray(source, 'categoryDiscounts', function (obj) {
          return {
            cmCategoryId: conversions.toDocumentReferenceId(obj.cmCategoryId),
            discount1: obj.discount1,
            discount2: obj.discount2
          };
        })
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutSubSettings_1.SelloutSubSettings(SelloutSubSettings_1.SelloutSubSettings.schema.remodelingDaysBeforeClosure.valueOf(source.remodelingDaysBeforeClosure), SelloutSubSettings_1.SelloutSubSettings.schema.categoryDiscounts.valueOf(conversions.asObjectList(source, 'categoryDiscounts', function (doc) {
        return new SelloutCategoryDiscount_1.SelloutCategoryDiscount(SelloutCategoryDiscount_1.SelloutCategoryDiscount.schema.cmCategoryId.valueOf(conversions.toClassReferenceId(doc.cmCategoryId)), SelloutCategoryDiscount_1.SelloutCategoryDiscount.schema.discount1.valueOf(doc.discount1), SelloutCategoryDiscount_1.SelloutCategoryDiscount.schema.discount2.valueOf(doc.discount2));
      })));
    }
  }]);

  return SelloutSubSettingsConverterImpl;
}(SelloutSubSettingsConverter_1.SelloutSubSettingsConverter);

exports.SelloutSubSettingsConverterImpl = SelloutSubSettingsConverterImpl;